<template>
  <div>
    <div class="layer-shade" v-if="isShow">
      <a-spin :tip="message" class="login_wrap" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
      message: "",
    };
  },

  methods: {
    show(message) {
      this.isShow = true;
      this.message = message;
    },
    hide() {
      this.isShow = false;
    },
  },
};
</script>

<style lang="less" scoped>
.layer-shade {
  z-index: 100000;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  .login_wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>